export type RepoLink = {
  label: string;
  url: string;
  icon: string;
};

export type Repo = {
  name: string;
  description: string;
  tags: string[];
  language: string;
  url: string;
  accent: string;
  status?: string;
  icon?: string;
  image?: string;
  imageAlt?: string;
  featured?: boolean;
  actionLabel?: string;
  links?: RepoLink[];
};

export const repoData: Repo[] = [
  {
    name: "RokRage Excel Viewer",
    description: "Open formatted XLSX workbooks and CSV files locally inside VS Code or VSCodium, with search, filters, pagination and export.",
    tags: ["XLSX", "CSV", "Local-first"],
    language: "TypeScript",
    url: "/excel-viewer/",
    accent: "linear-gradient(135deg, #72e3c2, #00a86b)",
    status: "Read-only · private",
    icon: "/excel-viewer-icon.png",
    image: "/excel-viewer.png",
    featured: true,
    links: [
      {
        label: "Marketplace",
        url: "https://marketplace.visualstudio.com/items?itemName=rokrage.rokrage-excel-viewer",
        icon: "deployed_code"
      },
      {
        label: "Open VSX",
        url: "https://open-vsx.org/extension/rokrage/rokrage-excel-viewer",
        icon: "extension"
      }
    ]
  },
  {
    name: "RokRage VSDX Viewer",
    description: "Preview modern Visio drawings without leaving your editor, with page tabs, crisp vector zoom, free panning and text search.",
    tags: ["VSDX", "Visio", "Local-first"],
    language: "TypeScript",
    url: "/vsdx-viewer/",
    accent: "linear-gradient(135deg, #6bbcff, #3767e8)",
    status: "Read-only · private",
    icon: "/vsdx-viewer-icon.png",
    image: "/vsdx-viewer.png",
    featured: true,
    links: [
      {
        label: "Marketplace",
        url: "https://marketplace.visualstudio.com/items?itemName=rokrage.vsdx-viewer",
        icon: "deployed_code"
      },
      {
        label: "Open VSX",
        url: "https://open-vsx.org/extension/rokrage/vsdx-viewer",
        icon: "extension"
      }
    ]
  },
  {
    name: "Stylish Markdown PDF",
    description: "Preview Markdown with polished themes and export presentation-ready PDFs locally, with page controls, cover metadata and no document uploads.",
    tags: ["Markdown", "PDF", "Local-first"],
    language: "TypeScript",
    url: "/markdown-pdf/",
    accent: "linear-gradient(135deg, #6657f4, #21b8a5)",
    status: "Private · local export",
    icon: "/stylish-markdown-pdf-icon.png",
    image: "/stylish-markdown-pdf.png",
    imageAlt: "Stylish Markdown PDF Modern theme previewing a synthetic RokRage product brief",
    featured: true,
    links: [
      {
        label: "Marketplace",
        url: "https://marketplace.visualstudio.com/items?itemName=RokRage.stylish-markdown-pdf",
        icon: "deployed_code"
      },
      {
        label: "Open VSX",
        url: "https://open-vsx.org/extension/rokrage/stylish-markdown-pdf",
        icon: "extension"
      }
    ]
  },
  {
    name: "RokSprite Lite",
    description: "Draw sprites and tile sets directly in VS Code or VSCodium, with pixel tools, palettes, minimap navigation, image resizing and PNG export.",
    tags: ["Pixel art", "Sprites", "Tile atlas"],
    language: "TypeScript",
    url: "/rok-sprite-lite/",
    accent: "linear-gradient(135deg, #8f7cff, #d6b84b)",
    status: "Editable · local-first",
    icon: "/rok-sprite-lite-icon.png",
    image: "/rok-sprite-lite.png",
    imageAlt: "RokSprite Lite editing a synthetic 64 by 64 pixel-art character in VS Code",
    featured: true,
    links: [
      {
        label: "Marketplace",
        url: "https://marketplace.visualstudio.com/items?itemName=RokRage.rok-sprite-lite",
        icon: "deployed_code"
      },
      {
        label: "Open VSX",
        url: "https://open-vsx.org/extension/rokrage/rok-sprite-lite",
        icon: "extension"
      }
    ]
  },
  {
    name: "HL7 Message Explorer",
    description: "Explore and edit HL7 v2.x messages in the browser with field descriptions, component breakdowns, bundled samples and optional HTTP sending.",
    tags: ["HL7 v2", "Field explorer", "Browser-local"],
    language: "JavaScript",
    url: "https://hl-7-parser-syntax.vercel.app",
    accent: "linear-gradient(135deg, #6177ff, #f06f61)",
    status: "Live web app",
    icon: "/hl7-message-explorer.png",
    image: "/hl7-message-explorer.jpg",
    imageAlt: "HL7 Message Explorer showing a public sample message and its field breakdown",
    actionLabel: "Open web app",
    links: [
      {
        label: "Source",
        url: "https://github.com/RokRage/HL7-Parser-Syntax",
        icon: "code"
      }
    ]
  },
  {
    name: "Mouse Smoothly",
    description: "macOS menu bar utility that gives mouse-wheel scrolling display-link timing and a calmer, trackpad-like glide.",
    tags: ["macOS", "Utility", "Input"],
    language: "Swift",
    url: "https://github.com/RokRage/Mouse-Smoothly",
    accent: "linear-gradient(135deg, #ff9d6c, #ffca7a)",
    status: "Open source",
    icon: "/mouse-smoothly.png",
    image: "/mouse-smoothly-app.png",
    imageAlt: "Mouse Smoothly menu showing speed, friction and acceleration curve controls"
  },
  {
    name: "HL7 ORU",
    description: "Mirth Connect scripts that turn HL7 ORU^R01 messages into grouped JSON for logging and downstream connectors.",
    tags: ["HL7", "Integration", "Mirth"],
    language: "JavaScript",
    url: "https://github.com/RokRage/HL7-ORU",
    accent: "linear-gradient(135deg, #c38cff, #7d7bff)",
    status: "Open source"
  }
];
